export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10930.c9c24cd3.jpg";